var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex"},[_c('v-progress-circular',{staticClass:"mx-auto",attrs:{"size":100,"width":5,"color":_vm.$vuetify.theme.dark
                ? _vm.$vuetify.theme.themes.dark.primary
                : _vm.$vuetify.theme.themes.light.primary,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }